import {
    AlertType, InputsRefs, KEY_CODE_ESCAPE, TipoVariacao, VariacaoProduto, barraVermelhoAzul,
    bgBlue, bgRed, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul,
    classbtColunasVermelho, focusLabelRed, focusRed
} from '../../Utils/Types'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ProdutoService } from '../../Pages/Products/ProdutoService'
import { SearchBox } from '../SearchBox/SearchBox'
import { useParams } from 'react-router-dom'
import { ModalCadVariacao } from '../ModalCadVariacao/modal-cada-variacao'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { GiArchiveRegister } from 'react-icons/gi'
import { FaSave } from 'react-icons/fa'


type Props = {
    loading?: boolean
    visible: boolean
    buttonConfirmClick?: () => void
    CloseModalEvent: React.MouseEventHandler<HTMLButtonElement>
    SalvarGrade: (codBarraGrade: string, idVariacaoGrade: number, idSubVariacaoGrade: number, estoqueSaldoGrade: string) => void
    onClose?: () => void
}

export const ModalCriarGrade = React.memo(({ loading, visible, buttonConfirmClick, CloseModalEvent, SalvarGrade, onClose }: Props) => {

    const { idProd } = useParams()
    const { idProdDup } = useParams()

    /* atributos variação */
    const [tipoVariacao, setTipoVariacao] = useState<TipoVariacao>("V")
    const [modalVariacaoVisible, setModalVariacaoVisible] = useState(false)
    const [variacaoList, setVariacaoList] = useState<VariacaoProduto[]>([])
    const [loadingSaveVariacao, setLoadingSaveVariacao] = useState<boolean>(false)
    const [loadingDelete, setLoadingDelete] = useState<boolean>(false)
    const [loadingDados, setLoadingDados] = useState<boolean>(false)
    const [descModalCadVariacao, setDescModalCadVariacao] = useState("")

    /* Atributos da grade de produtos */
    const [cod_barra_grade, setCodBarraGrade] = useState("")
    const [estoqueGrade, setEstoqueGrade] = useState("")
    const [idSubVariacao, setIdSubVariacao] = useState(0)
    const [idVariacao, setIdVariacao] = useState(0)

    // variáveis para as mensagens de feedback
    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    /* atributos subVariação */
    const [subVariacaoList, setSubVariacaoList] = useState<VariacaoProduto[]>([])

    const [gradeAttributes, setGradeAttributes] = useState<VariacaoProduto[]>([])

    const [visibleSearchBoxVariacao, setVisibleSearchBoxVariacao] = useState<boolean>(false)
    const [visibleSearchBoxSubVariacao, setVisibleSearchBoxSubVariacao] = useState<boolean>(false)
    const [visible_modal_additem, setVisible_modal_additem] = useState(false)

    const getAttributes = async () => {

        setVisibleMsg(false)
        setLoadingDados(true)

        try {

            const grade = await ProdutoService.GetAttributesGrade()

            let newVariacaoList = grade.data.filter((item: any) => item.tipo === "V")
            setVariacaoList(newVariacaoList || [])

            newVariacaoList = grade.data.filter((item: any) => item.tipo === "S")
            setSubVariacaoList(newVariacaoList || [])

            setGradeAttributes(grade.data)

            /*
            const attributes = await ProdutoService.GetAttributes(idProd || idProdDup)

            let newVariacaoList = attributes.data.variacaoProdutos?.filter((item: any) => item.tipo === "V")
            setVariacaoList(newVariacaoList || [])

            newVariacaoList = attributes.data.variacaoProdutos?.filter((item: any) => item.tipo === "S")
            setSubVariacaoList(newVariacaoList || [])

            setGradeAttributes(attributes.data)
            */

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao buscar os dados`)

        } finally {
            setLoadingDados(false)
        }

    }

    useEffect(() => {

        if (visible) {

            getAttributes()

            let modal = document.getElementById('modal_criar_grade')
            let modalContent = document.getElementById('modal_content_criar_grade')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-24')
                }
            }

            const aguarde = setTimeout(() => {
                const inputCNPJ = document.getElementById('cod_barras')
                if (inputCNPJ) {
                    inputCNPJ.focus()
                    clearTimeout(aguarde)
                }
            }, 200)

        } else {

            setVisibleMsg(false)

            setCodBarraGrade("")
            setEstoqueGrade("")
            setIdSubVariacao(0)
            setIdVariacao(0)

            searchBoxFocus()

            let modal = document.getElementById('modal_criar_grade')
            let modalContent = document.getElementById('modal_content_criar_grade')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-24')
                }
            }

        }

    }, [visible])

    const handleConfirmClick = () => {

        if (buttonConfirmClick) {
            buttonConfirmClick()
        }
    }

    const handleKeyPressESC = (event: any) => {

        if (event.code === KEY_CODE_ESCAPE && !visible_modal_additem) {

            if (onClose) {
                onClose()
            }
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressESC)

        return () => {
            document.removeEventListener('keydown', handleKeyPressESC)

        }
    }, [visible_modal_additem])

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    //------------------------------------------------------------------------ VARIAÇÃO -----------------------------------------------------------------------------//
    const handleClearVariacaoSelecionada = useCallback(() => {
        const newVariacaoList = [...(gradeAttributes?.filter(item => item.tipo === "V") || [])]
        setVariacaoList(newVariacaoList)
        setIdVariacao(0)
        boxFocusVariacao()
    }, [gradeAttributes])

    const handleFilterVariacaoClick = useCallback(async (description: string) => {

        if (description === "") {

            const newVariacaoList = [...(gradeAttributes?.filter(item => item.tipo === "V") || [])]
            setVariacaoList(newVariacaoList || [])

        } else {

            const newVariacaoList = [...(gradeAttributes || [])].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) && item.tipo === "V"
            })
            setVariacaoList(newVariacaoList || [])

        }

    }, [gradeAttributes])

    const handleVariacaoSelectClick = useCallback((v: VariacaoProduto) => {

        if (v) {
            const newVariacaoList = [...(gradeAttributes?.filter(item => item.tipo === "V") || [])]
            setVariacaoList(newVariacaoList)
            setIdVariacao(v.id)
        }

        setVisibleSearchBoxVariacao(false)
        boxFocusVariacao()
    }, [gradeAttributes])

    const handleAddVariacao = useCallback(() => {
        setDescModalCadVariacao(localStorage.getItem("@ecommerce/desc_variacao") || "Variacao")
        setTipoVariacao("V")
        setModalVariacaoVisible(true)
        setVisible_modal_additem(true)
        setVisibleMsg(false)
    }, [gradeAttributes])

    const handleDeleteVariacao = useCallback(async (id: number) => {

        setLoadingDelete(true)
        setVisibleMsg(false)

        try {

            const retAPI = await ProdutoService.DeleteVariacao(id)

            if (retAPI.error) {

                let newList = variacaoList.filter((item: VariacaoProduto) => item.tipo === "V")
                setVariacaoList(newList)

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || '')
                return
            }

            /*
            const attributes = await ProdutoService.GetAttributes(idProd || idProdDup)
            setGradeAttributes(attributes.data)
            */

            const grade = await ProdutoService.GetAttributesGrade()
            setGradeAttributes(grade.data)

            let newVariacaoList = retAPI.data.filter((item: VariacaoProduto) => item.tipo === "V")
            setVariacaoList(newVariacaoList)

            if (idVariacao === id) {
                setIdVariacao(0)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao deletar a variação`)

        } finally {
            boxFocusVariacao()
            inputFocusVariacao()

            setLoadingDelete(false)
        }

    }, [gradeAttributes, idVariacao])

    const handleSaveVariacao = useCallback(async (desc: string) => {

        /*
        if (!desc) {
            setVisibleMsg(true)
            setMessage(`A descrição não foi informada`)
            setMessageType("DANGER")
            return
        }
    
        if (!tipoVariacao) {
            setVisibleMsg(true)
            setMessage(`O tipo da variação não foi informado`)
            setMessageType("DANGER")
            return
        }
        */

        setVisibleMsg(false)
        setLoadingSaveVariacao(true)

        try {

            const retApi = await ProdutoService.AddVariacao(desc, tipoVariacao)

            /*
            const attributes = await ProdutoService.GetAttributes(idProd || idProdDup)
            setGradeAttributes(attributes.data)
            */

            const grade = await ProdutoService.GetAttributesGrade()
            setGradeAttributes(grade.data)

            if (retApi.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(retApi.msg || '')

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage(`Os dados foram gravados com sucesso`)

                if (retApi.data) {
                    let newVariacaoList = retApi.data.filter((item: VariacaoProduto) => item.tipo === "V")
                    setVariacaoList(newVariacaoList)

                    newVariacaoList = retApi.data.filter((item: VariacaoProduto) => item.tipo === "S")
                    setSubVariacaoList(newVariacaoList)
                }

                if (visibleSearchBoxVariacao) {

                    inputFocusVariacao()

                } else if (visibleSearchBoxSubVariacao) {

                    inputFocusSubVariacao()
                }

                setModalVariacaoVisible(false)
                setVisible_modal_additem(false)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao salvar a variação`)

        } finally {
            setLoadingSaveVariacao(false)
        }

    }, [tipoVariacao, idProd, idProdDup, visibleSearchBoxVariacao, visibleSearchBoxSubVariacao])


    //------------------------------------------------------------------------ SUBVARIAÇÃO --------------------------------------------------------------------------------//
    const handleClearSubVariacaoSelecionada = useCallback(() => {
        const newVariacaoList = [...(gradeAttributes?.filter(item => item.tipo === "S") || [])]
        setSubVariacaoList(newVariacaoList)
        setIdSubVariacao(0)

        setVisibleSearchBoxSubVariacao(false)
        boxFocusSubVariacao()
    }, [gradeAttributes])

    const handleFilterSubVariacaoClick = useCallback(async (description: string) => {

        if (description === "") {

            const newVariacaoList = [...(gradeAttributes?.filter(item => item.tipo === "S") || [])]
            setSubVariacaoList(newVariacaoList || [])

        } else {

            const newVariacaoList = [...(gradeAttributes || [])].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()) && item.tipo === "S"
            })

            setSubVariacaoList(newVariacaoList || [])
        }

    }, [gradeAttributes])

    const handleSubVariacaoSelectClick = useCallback((v: VariacaoProduto) => {

        if (v) {
            const newVariacaoList = [...(gradeAttributes?.filter(item => item.tipo === "S") || [])]
            setSubVariacaoList(newVariacaoList)
            setIdSubVariacao(v.id)
        }

        setVisibleSearchBoxSubVariacao(false)
        boxFocusSubVariacao()

    }, [gradeAttributes])

    const handleAddSubVariacao = useCallback(() => {
        setDescModalCadVariacao(localStorage.getItem("@ecommerce/desc_sub_variacao") || "Sub Variacao")
        setTipoVariacao("S")
        setModalVariacaoVisible(true)
        setVisible_modal_additem(true)
        setVisibleMsg(false)
    }, [gradeAttributes])

    const handleDeleteSubVariacao = useCallback(async (id: number) => {

        setLoadingDelete(true)
        setVisibleMsg(false)

        try {

            const retAPI = await ProdutoService.DeleteVariacao(id)

            if (retAPI.error) {

                let newList = subVariacaoList.filter((item: VariacaoProduto) => item.tipo === "S")
                setSubVariacaoList(newList)

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || '')
                return
            }

            /*
            const attributes = await ProdutoService.GetAttributes(idProd || idProdDup)
            setGradeAttributes(attributes.data)
            */

            const grade = await ProdutoService.GetAttributesGrade()
            setGradeAttributes(grade.data)

            let newSubVariacaoList = retAPI.data.filter((item: VariacaoProduto) => item.tipo === "S")
            setSubVariacaoList(newSubVariacaoList)

            if (idSubVariacao === id) {
                setIdSubVariacao(0)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao deletar a subvariação`)

        } finally {

            boxFocusSubVariacao()
            inputFocusSubVariacao()

            setLoadingDelete(false)
        }

    }, [gradeAttributes, idSubVariacao])


    //------------------------------------------------------------------------ GRADE --------------------------------------------------------------------------------//
    const handleCodBarraGradeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodBarraGrade(e.target.value)
    }

    const handleChangeEstoqueGrade = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEstoqueGrade(e.target.value.replace(/[^0-9]/g, ''))
    }

    const saveGrade = () => {

        SalvarGrade(cod_barra_grade, idVariacao, idSubVariacao, estoqueGrade)
    }

    const fecharModalCadVariacao = () => {

        setModalVariacaoVisible(false)
        setVisibleMsg(false)
        setVisible_modal_additem(false)

        if (tipoVariacao === 'V') {

            boxFocusVariacao()
            inputFocusVariacao()

        } else if (tipoVariacao === 'S') {

            boxFocusSubVariacao()
            inputFocusSubVariacao()
        }
    }

    // ---------------------------------------------------------------- FOCUS ---------------------------------------------------------------------------------------//
    const inputsRefs: InputsRefs = {
        codBarraGrade: useRef(null),
        variacaoGrade: useRef(null),
        subVariacaoGrade: useRef(null),
        estoque: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            if (nextIndex === 1) {
                setVisibleSearchBoxVariacao(true)
                inputFocusVariacao()
            }

            if (nextIndex === 2 && idVariacao > 0) {
                setVisibleSearchBoxSubVariacao(true)
                inputFocusSubVariacao()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {

        const handleKeyDown = (event: KeyboardEvent) => {

            const inputSearchVariacao = document.getElementById('inputSearchBox-variacao') as HTMLInputElement
            const inputSearchSubVariacao = document.getElementById('inputSearchBox-subvariacao') as HTMLInputElement

            if (event.key === 'Tab' && visible && document.activeElement === inputSearchVariacao) {

                if (idVariacao > 0) {

                    clickSearchBoxSubVariacao()

                } else {

                    inputsRefs['estoque'].current?.focus()
                    setVisibleSearchBoxVariacao(false)
                }

            } else if (event.key === 'Tab' && visible && document.activeElement === inputSearchSubVariacao) {
                inputsRefs['estoque'].current?.focus()
                setVisibleSearchBoxSubVariacao(false)
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [visible, idVariacao])

    const searchBoxFocus = () => {
        setVisibleSearchBoxVariacao(false)
        setVisibleSearchBoxSubVariacao(false)
    }

    // VARIACAO
    const boxFocusVariacao = () => {
        // Move o foco para o input correspondente à chave 'variacaoGrade'.
        inputsRefs['variacaoGrade'].current?.focus()
    }

    const clickSearchBoxVariacao = useCallback(() => {
        setVisibleSearchBoxVariacao((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxSubVariacao(false)
                inputFocusVariacao()
            }
            return newState
        })

        boxFocusVariacao()
    }, [])

    const inputFocusVariacao = () => {
        let inputSearch = document.getElementById(`inputSearchBox-variacao`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // SUBVARIACAO
    const boxFocusSubVariacao = () => {
        // Move o foco para o input correspondente à chave 'subVariacaoGrade'.
        inputsRefs['subVariacaoGrade'].current?.focus()
    }

    const clickSearchBoxSubVariacao = useCallback(() => {
        setVisibleSearchBoxSubVariacao((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxVariacao(false)
                inputFocusSubVariacao()
            }
            return newState
        })

        boxFocusSubVariacao()
    }, [])

    const inputFocusSubVariacao = () => {
        let inputSearch = document.getElementById(`inputSearchBox-subvariacao`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    const nomeVariacao = localStorage.getItem("@ecommerce/desc_variacao")
    const nomeSubVariacao = localStorage.getItem("@ecommerce/desc_sub_variacao")

    return (

        <div id="modal_criar_grade" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_criar_grade" className={`relative flex flex-col w-[80%] md:w-[50%] lg:w-[30%] xl:w-[20%] h-[400px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <GiArchiveRegister size={20} className={`w-5 h-5 text-slate-800 dark:text-slate-100`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Cadastro - Grade</span>

                </div>

                <div className={`absolute top-[70px] w-full h-full px-3 py-4`}>

                    <div className={`grid grid-cols-12 gap-5`}>

                        <div className={`relative col-span-12`}>

                            <div className={`${barraVermelhoAzul} ${cod_barra_grade != '' ? bgBlue : bgRed}`} />

                            <input ref={inputsRefs.codBarraGrade} onKeyDown={(e) => handleTabPress(e, 'codBarraGrade')} id="cod_barras" className={`${classInput} ${classInputDark} ${cod_barra_grade != '' ? '' : focusRed}`} type="text" inputMode='text' placeholder=" " autoComplete='off' value={cod_barra_grade} onFocus={searchBoxFocus} onChange={handleCodBarraGradeChange} />
                            <label htmlFor="cod_barras" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${cod_barra_grade != '' ? '' : focusLabelRed}`}>Cód.Barras / Ref</label>
                        </div>

                        <div className={`relative col-span-12`}>

                            <div ref={inputsRefs['variacaoGrade']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'variacaoGrade')} />
                            <div className={`${barraVermelhoAzul} ${idVariacao > 0 ? bgBlue : bgRed}`} />

                            <SearchBox
                                dataList={variacaoList}
                                idRegistro={idVariacao || undefined}
                                label={nomeVariacao || "Variação"}
                                componentId='variacao'
                                borda={true}
                                visibleAddItem={visible_modal_additem}
                                loading={loadingDelete}
                                visibleTAB={visibleSearchBoxVariacao}
                                setDataClick={handleVariacaoSelectClick}
                                clearDataClick={handleClearVariacaoSelecionada}
                                deleteDataClick={handleDeleteVariacao}
                                filterDataClick={handleFilterVariacaoClick}
                                additem={handleAddVariacao}
                                clicado={clickSearchBoxVariacao}
                            />
                        </div>

                        <div className={`relative col-span-12`}>

                            <div ref={inputsRefs['subVariacaoGrade']} tabIndex={idVariacao > 0 ? 0 : -1} onKeyDown={(e) => handleTabPress(e, 'subVariacaoGrade')} />
                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />

                            <SearchBox
                                disabled={idVariacao === 0}
                                dataList={subVariacaoList}
                                idRegistro={idSubVariacao || undefined}
                                label={nomeSubVariacao || "Subvariação"}
                                componentId='subvariacao'
                                visibleAddItem={visible_modal_additem}
                                loading={loadingDelete}
                                visibleTAB={idVariacao > 0 ? visibleSearchBoxSubVariacao : false}
                                setDataClick={handleSubVariacaoSelectClick}
                                clearDataClick={handleClearSubVariacaoSelecionada}
                                deleteDataClick={handleDeleteSubVariacao}
                                filterDataClick={handleFilterSubVariacaoClick}
                                additem={handleAddSubVariacao}
                                clicado={clickSearchBoxSubVariacao}
                            />
                        </div>

                        <div className={`relative col-span-12`}>

                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />

                            <input ref={inputsRefs.estoque} onKeyDown={(e) => handleTabPress(e, 'estoque')} id="estoque_grade" className={`${classInput} ${classInputDark} `} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={estoqueGrade} onFocus={searchBoxFocus} onChange={handleChangeEstoqueGrade} />
                            <label htmlFor="estoque_grade" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Estoque</label>
                        </div>

                    </div>

                </div>

                {loadingDados &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={CloseModalEvent}
                        className={`${classbtColunasVermelho} sm:max-w-[150px]`}>

                        CANCELAR
                    </button>

                    <button
                        onClick={saveGrade}
                        className={`${classbtAzul} ${classBt} sm:max-w-[150px]`}>
                        {!loading && <FaSave size={"18px"} className='mr-2' />}
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `SALVAR` : `AGUARDE`}
                    </button>

                </div>

                <ModalCadVariacao
                    visible={modalVariacaoVisible}
                    titulo={descModalCadVariacao}
                    tipoRegistro={tipoVariacao}
                    loading={loadingSaveVariacao}
                    closeModal={fecharModalCadVariacao}
                    saveData={handleSaveVariacao}
                />

            </div>

        </div>

    )

})